module.exports = __webpack_public_path__ + "images/e8b8e5c724cc155787d29787dd357640.png";